import './App.css';
import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Header from './Header';
import NewsBar from './Components/NewsBar';
import Footer from './Components/Footer';
import FloatingWhatsApp from './Components/FloatingWhatsApp';
import { ContentProvider } from './data/content';

// The admin module is a separate bundle with its own chrome and providers.
const AdminApp = lazy(() => import('./admin/AdminApp'));

function PublicSite() {
  return (
    <div className="app">
      {/* the strip runs above the sticky header, so every page opens moving */}
      <NewsBar />
      <Header />
      <AppRoutes />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <ContentProvider>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div style={{ padding: 40 }}>Loading admin…</div>}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="/*" element={<PublicSite />} />
      </Routes>
    </ContentProvider>
  );
}

export default App;
